import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import EditIcon from '@mui/icons-material/Edit'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import Autocomplete from '@mui/material/Autocomplete'

import { BootstrapDialog, BootstrapDialogTitle } from '../shared/BootstrapDialog'
import { AdminBookModalStyle } from '../styles'
import { updateTag } from '../../reducers/tagsReducers'
import { setErrorNotification } from '../../reducers/notificationReducer'
import TagSelector from '../tags/TagSelector'

const AdminTagModal = ({ tag, activeTagType, contentCategories }) => {
    const user = useSelector(state => state.user)
    const dispatch = useDispatch()

    const [open, setOpen] = useState(false)
    const [name, setName] = useState(tag.name)
    const [category, setCategory] = useState(tag.category || '')
    const [personas, setPersonas] = useState(tag.personas || [])

    const handleClickOpen = () => {
        setName(tag.name)
        setCategory(tag.category || '')
        setPersonas(tag.personas || [])
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleSave = () => {
        if (activeTagType === 'tcairem' && personas.length === 0) {
            dispatch(setErrorNotification('Select at least one persona'))
            return
        }

        const trimmedName = name.trim()

        const data = {
            name: trimmedName,
        }

        if (activeTagType === 'content') {
            data.category = category || null
        }

        if (activeTagType === 'tcairem') {
            // Required — a PUT with no personas would 400.
            data.personas = personas
        }

        dispatch(updateTag(tag.id, data, user.staff, activeTagType))
        handleClose()
    }

    return (
        <div>
            <Button {...AdminBookModalStyle.viewButton.props} onClick={handleClickOpen} sx={AdminBookModalStyle.viewButton.style}>
                <EditIcon /> &nbsp; Edit
            </Button>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby={`tag-modal-${tag.id}`}
                open={open}
                fullWidth
                maxWidth="sm"
            >
                <BootstrapDialogTitle id={`tag-modal-${tag.id}`} onClose={handleClose}>
                    <Box sx={AdminBookModalStyle.titleContainer}>
                        <LocalOfferIcon sx={{ marginRight: '10px' }} />
                        Edit Tag
                    </Box>
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Typography variant="h6" gutterBottom>
                        Tag Details
                    </Typography>
                    <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                value={name}
                                onChange={e => setName(e.target.value)}
                                label="Name"
                                required
                            />
                        </Grid>
                        {activeTagType === 'content' && (
                            <Grid item xs={12}>
                                <Autocomplete
                                    options={contentCategories}
                                    getOptionLabel={(option) => option.name || ''}
                                    value={contentCategories.find(c => c.id === category) || null}
                                    onChange={(_, newValue) => setCategory(newValue ? newValue.id : '')}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Category (optional)"
                                            helperText="Select a category for this content tag"
                                        />
                                    )}
                                />
                            </Grid>
                        )}
                        {activeTagType === 'tcairem' && (
                            <Grid item xs={12}>
                                <TagSelector
                                    tagType='tcairemPersona'
                                    label='Personas'
                                    selectedTags={personas}
                                    onChange={setPersonas}
                                    required
                                />
                            </Grid>
                        )}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button autoFocus onClick={handleSave}>
                        Save Changes
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    )
}

export default AdminTagModal
